<template>
<div>
  <div class="p-3 border-top text-right">
    <span class="text-muted">&copy; iAMconnected <span v-text="date"></span></span>
  </div>
</div>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
   return {
   }
  },
  props: {
  },
  computed: {
   date(){
    return new Date().getFullYear();
   },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
